import axios, { AxiosResponse } from "axios";
import getApiBaseUrl from "../GetServer";

export interface CalculatorData {
  id: number;
  minQueries: number;
  maxQueries: number;
  minTime: number;
  maxTime: number;
  minCost: number;
  maxCost: number;
  botSaving: number;
}

export interface CalculatorResponse {
  statusCode: number;
  message: string;
  data: CalculatorData;
}

export const CalculatorRequest = async (): Promise<CalculatorResponse> => {
  const baseUrl = getApiBaseUrl();
  const endpoint = `${baseUrl}calculator/get`;

  try {
    const response: AxiosResponse<CalculatorResponse> = await axios.get(
      endpoint
    );

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};
